<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/GwHU4B/tc-custom/9781504066792.jpg?1726454431795" alt="This image is the cover for the book Six Crystal Princesses, The Xanth Novels"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Six Crystal Princesses, The Xanth Novels
      </h1>
      <p class="bookDescription body article font2">
        <b>In this heroic Xanth adventure from the <i>New York Times</i>–bestselling author, there’s no time like the present to free six plucky princesses from the past.</b><br/>  <br/> Young Vinia is enjoying her life with her boyfriend, Prince Ion. They complement each other perfectly: her telekinesis helps him walk, and his ambiance abolishes all allergens, allowing her to breathe freely. But Ion and his twin, Hilda, are bored with their easy royal lives and are restless for an adventure . . .<br/>  <br/> While telling the story of how their parents met, the twins remember their mother was once captured by a dragon and frozen in crystal along with a half dozen other strong-willed princesses. She managed to escape, but the six other maidens continue to be held captive—which gives Vinia, Ion, Hilda, and Hilda’s caprine-crossbreed boyfriend the perfect excuse to embark on a quest.<br/>  <br/> But first they must get the approval of their parents—and the Good Magician. Since Vinia is the protagonist in this story (though she’s much more comfortable as a background character), it’s up to her complete the Magician’s challenges. And then comes their greatest test: to free the princesses from their patriarchal prison, frozen in place by the Dragon with the Girl Tattoo . . .<br/>  <br/><b>Praise for Piers Anthony</b><br/>  <br/> “Piers Anthony is one of those authors who can perform magic with the ordinary. . . . [He] is a craftsman.” —<i>A Reader’s Guide to Science Fiction</i><br/>  <br/> “Anthony’s unflagging sparkle, verve and wordplay spin everyday trials of Mundane life into storytelling gold.” —<i>Publishers Weekly</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Piers Anthony
      </h2>
      
      <p class="authorDescription body article"> Piers Anthony is one of the world&rsquo;s most popular fantasy writers, and a&#160;<I>New York Times</I>&ndash;bestselling author twenty-one times over. His Xanth novels have been read and loved by millions of readers around the world, and he daily receives letters from his devoted fans. In addition to the Xanth series, Anthony is the author of many other bestselling works. He lives in Inverness, Florida. </p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0a95ae33